module.exports = __webpack_public_path__ + "media/fonts/fa-regular-400-d489802edd712a4e8c901158fd704d58.eot";